<template>
  <div class="container">
    <div class="card" style="width: 18rem">
      <div class="card-body">
        <div class="card-text">
          <div class="row">
            <div class="col-6">
              <input
                type="text"
                class="form-control"
                placeholder="Org name"
                v-model="name"
              />
            </div>
            <div class="col">
              <div class="dropdown" v-if="name.length">
                <button
                  class="btn btn-secondary dropdown-toggle"
                  type="button"
                  id="dropdownMenuButton1"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  {{ fy_start }}
                </button>
                <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                  <li
                    v-for="m in months"
                    :key="m"
                    class="dropdown-item"
                    @click="setFYStart(m)"
                  >
                    {{ m }}
                  </li>
                </ul>
              </div>
            </div>
            <div class="col">
              <span class="badge rounded-pill bg-success" v-if="name.length"
                >Active</span
              >
            </div>
            <div class="col text-center">
              <button
                class="btn btn-primary"
                v-if="name.length"
                @click="addOrg()"
              >
                Add
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { useStore } from "../../store/index";
import { auth, db } from "../../firebase/config";
import { collection, addDoc } from "firebase/firestore";
import { ref } from "vue";
const store = useStore();
const name = ref("");
const fy_start = ref("Apr");
const months = ref([
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
]);
const setFYStart = (m) => {
  fy_start.value = m;
};
const addOrg = async () => {
  const orgObj = {
    user: auth.currentUser.uid,
    name: name.value,
    active: true,
    fy_start: fy_start.value,
  };
  await addDoc(collection(db, "orgs"), orgObj);
  name.value = "";
  fy_start.value = "Mar";
  store.setAction("");
};
</script>
